<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-cube mr-2" />Model</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter.name"
                            type="search"
                            id="filterInput"
                            placeholder="Nama"
                            @keyup.enter="getItems"
                        />
                        <multiselect v-model="filter.kategori"
                            class="mr-2"
                            :options="optKategori"
                            :allow-empty="true"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Kategori"
                        />
                        <b-form-select class="mr-2" v-model="filter.sort" :options="optSort">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Sortir...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search" />
                        </b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="primary" @click="$bvModal.show('modal-input')">Buat Model Baru</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada model.
                </template>
                <template v-slot:cell(foto)="row">
                    <div v-if="row.item.foto == null">No Photo</div>
                    <a v-else :href="$BASE_FILE_PATH + row.item.foto" target="_blank">
                        <img :src="$BASE_FILE_PATH + row.item.foto" height="40" />
                    </a>
                </template>
                <template v-slot:cell(kategori)="row">
                    {{ row.item.kategori.name }}
                </template>
                <template v-slot:cell(harga)="row">
                    Rp. {{ $helper.formatThousandSeparator(row.item.minHarga) }} - <br />
                    Rp. {{ $helper.formatThousandSeparator(row.item.maxHarga) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-link class="mr-2" :to="`${$route.path}/${row.item.id}`">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Detail">
                            <i class="fa fa-fw fa-search" />
                        </b-button>
                    </b-link>
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Edit" @click="openEditModal(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <b-modal id="modal-input" title="Buat Model Baru"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="inputName" v-model="input.name" @keyup.enter="executeInput" maxlength="50" />
            </b-form-group>
            <b-form-group label="Kategori">
                <multiselect
                    v-model="input.kategori"
                    :options="optKategori"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih Kategori"
                />
            </b-form-group>
            <b-form-group label="Gambar">
                <b-form-file v-model="input.photo" accept="image/jpeg, image/png" placeholder="Foto (Opsional)" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit" title="Edit Model"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="editName" v-model="edit.name" @keyup.enter="executeEdit" maxlength="50" />
            </b-form-group>
            <b-form-group label="Kategori">
                <multiselect
                    v-model="edit.kategori"
                    :options="optKategori"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih Kategori"
                />
            </b-form-group>
            <b-form-group label="Gambar">
                <b-form-file v-model="edit.photo" accept="image/jpeg, image/png" placeholder="Foto (Opsional)" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEdit">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'model-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            input: {
                name: "",
                photo: null,
                kategori: null
            },

            edit: {
                name: "",
                photo: null,
                kategori: null
            },

            filter: {
                name: "",
                sort: 1,
                kategori: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "foto", label: "Foto" },
                { key: "name", label: "Nama" },
                { key: "kategori", label: "Kategori" },
                { key: "harga", label: "Range Harga" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: null,

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optKategori: [],
            optSort: [
                { text: "Nama A - Z", value: 1 },
                { text: "Nama Z - A", value: 2 },
                { text: "Harga Rendah ke Tinggi", value: 3 },
                { text: "Harga Tinggi ke Rendah", value: 4 }
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getKategoriOpt = this.$axios.get("kategori/").then(res => {
                this.optKategori = res.data
            })

            Promise.all([getItems, getKategoriOpt]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&sortBy=" + this.filter.sort

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if(!this.$helper.isBlank(this.filter.kategori)) {
                param += "&filterKategori=" + this.filter.kategori.id
            }

            // Execute
            return this.$axios.get("model/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.kategori)) {
                return this.$helper.toastError(this, "Kategori tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("name", this.input.name)
            payload.append("kategoriId", this.input.kategori.id)

            if(this.input.photo != null) {
                payload.append("foto", this.input.photo)
            }

            this.isSubmitting = true
            this.$axios.post("model/", payload).then(res => {

                this.totalRows++

                this.$bvModal.hide("modal-input")
                this.$helper.toastSuccess(this, "Model baru berhasil ditambahkan!")
                this.input.name = ""
                this.getItems(this.currentPage)

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("name", this.edit.name)
            payload.append("kategoriId", this.edit.kategori.id)

            if(this.edit.photo != null) {
                payload.append("foto", this.edit.photo)
            }

            this.isSubmitting = true
            this.$axios.post("model/", payload).then(res => {

                this.$bvModal.hide("modal-edit")
                this.$helper.toastSuccess(this, "Model berhasil diubah!")
                this.getItems(this.currentPage)

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        openEditModal(item) {

            this.activeItem = item
            this.edit.name = item.name
            this.edit.kategori = item.kategori
            this.$bvModal.show("modal-edit")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

    },

    created() {
        this.init()
    }

}
</script>
